import { isNil } from 'lodash';

export function isValidNumber(
    value: number,
    isRequired?: boolean,
    min?: number,
    max?: number,
): boolean {
    if (isRequired && (isNil(value) || isNaN(value))) {
        return false;
    }

    min = isNil(min) ? Number.NEGATIVE_INFINITY : min;
    max = isNil(max) ? Number.POSITIVE_INFINITY : max;
    return value >= min && value <= max;
}
